import Tooltip from '../../../../../../../common/_custom/Tooltip/Tooltip';
import { DirectorStatus, DirectorStatusText } from '../../../../../../../common/DirectorStatus/DirectorStatus';

interface DirectorSubLineProps {
    text: string;
    rawValue?: number | null;
    isTinyCollapsed: boolean;
    status: DirectorStatus;
}

/** The designation/shareholding sub-line under a director's name, with the Active/Former status
 * appended as its last segment. */
const DirectorSubLine = ({ text, rawValue, isTinyCollapsed, status }: DirectorSubLineProps) => {
    return (
        <>
            {isTinyCollapsed ? (
                <Tooltip content={`${rawValue}%`} direction="top" contentCss={{ whiteSpace: 'nowrap' }} fitContent small usePortal>
                    <span>{text}</span>
                </Tooltip>
            ) : (
                text
            )}
            {status && (
                <>
                    {text && ' • '}
                    <DirectorStatusText status={status} />
                </>
            )}
        </>
    );
};

export default DirectorSubLine;
